import React, { useState } from "react";
import { headerDropdown, logo } from "../../assets/images";
import { useTranslation } from "react-i18next";
import { Link, useLocation } from "react-router-dom";

const Header = () => {
  const { t, i18n } = useTranslation();
  const currentLanguage = i18n.language;
  const location = useLocation();

  const [oilGasOpen, setOilGasOpen] = useState(false);
  const [industrialSolutionsOpen, setIndustrialSolutionsOpen] = useState(false);
  const [isHamburgerMenuOpen, setIsHamburgerMenuOpen] = useState(false);

  const [servicesOpen, setServicesOpen] = useState(false);
  const [supplyOpen, setSupplyOpen] = useState(false);
  const [seperateServicesOpen, setSeperateServicesOpen] = useState(false);
  const [resatoServicesOpen, setResatoServicesOpen] = useState(false);

  const [servicesOpen2, setServicesOpen2] = useState(false);
  const [supplyOpen2, setSupplyOpen2] = useState(false);

  const [openIndex, setOpenIndex] = useState(null);
  const [openSubIndex, setOpenSubIndex] = useState(null);

  const toggleSubmenu = (index) => {
    setOpenIndex(openIndex === index ? null : index);
    setOpenSubIndex(null); // Alt submenu varsa kapat
  };

  const toggleNestedSubmenu = (index) => {
    setOpenSubIndex(openSubIndex === index ? null : index);
  };

  const menuItems = [
    { path: "", label: t("Home") },
    { path: "/about", label: t("About") },
    {
      path: "#",
      label: t("Oil & Gas Solutions"),
      submenu: [
        {
          path: "/supply",
          label: t("Supply"),
          submenu: [
            { path: "/supply/drillbits", label: t("Drill bits") },
            {
              path: "/supply/directional",
              label: t("Directional drilling (Downhole Motors)"),
            },
            {
              path: "/supply/fiber",
              label: t("Fiber glass tubes for cementing and coring job"),
            },
            { path: "/supply/liner", label: t("Liner hangers") },
            { path: "/supply/whipstock", label: t("Whipstocks") },
            { path: "/supply/corebit", label: t("Core bit") },
            {
              path: "/supply/resato",
              label: t(
                "Resato High Pressure Technology: High Pressure Applications"
              ),
              submenu: [
                {
                  path: "/supply/hydro",
                  label: t("Pressure testing: Hydrostatic pressure testing"),
                },
                {
                  path: "/supply/gas",
                  label: t("Pressure testing: Gas pressure testing"),
                },
                {
                  path: "/supply/pressure",
                  label: t("Pressure testing: Pressure test bays"),
                },
              ],
            },
          ],
        },
        {
          path: "/services",
          label: t("Services"),
          submenu: [
            {
              path: "#",
              label: t("Seperate services"),
              submenu: [
                {
                  path: "/services/directional",
                  label: t("Directional drillling"),
                },
                {
                  path: "/services/drillbits",
                  label: t("Drill bits (PDC/RC)"),
                },
                { path: "/services/reaming", label: t("Reaming services") },
                {
                  path: "/services/coring",
                  label: t("Coring & core analysis"),
                },
                {
                  path: "/services/upper",
                  label: t(
                    "Upper & lower completion & installation of downhole equipment"
                  ),
                },
              ],
            },
            {
              path: "/services/geological",
              label: t(
                "Geological Intelligence for Drilling: Powered by Advanced Software"
              ),
            },
            { path: "/services/ipm", label: t("IPM, ISM") },
            {
              path: "/services/resato",
              label: t("Resato High Pressure Technology"),
            },
          ],
        },
      ],
    },
    {
      path: "#",
      label: t("Industrial Solutions"),
      submenu: [
        {
          path: "/industrial/supply",
          label: t("Supply"),
          submenu: [
            {
              path: "/industrial/supply/pumps-compressor",
              label: t("Pumps, compressors"),
            },
            { path: "/industrial/supply/gloves", label: t("PPE Equipment") },
            {
              path: "/industrial/supply/hand-tools",
              label: t("Hand tools, measuring instruments"),
            },
          ],
        },
        {
          path: "/industrial/services",
          label: t("Services"),
          submenu: [
            {
              path: "/industrial/services/industrial",
              label: t("Industrial Insulation Services"),
            },
            {
              path: "/industrial/services/consultancy",
              label: t("Consultancy Services"),
            },
            {
              path: "/industrial/services/training",
              label: t("Training & Technical Support"),
            },
            {
              path: "/industrial/services/maintenance",
              label: t("Maintenance & Repair"),
            },
          ],
        },
      ],
    },
    { path: "/qhse", label: t("QHSE") },
  ];

  const isActiveLink = (path) => {
    if (path === `/${currentLanguage}`) {
      return location.pathname === `/${currentLanguage}`;
    }
    return location.pathname.startsWith(path);
  };

  const toggleHamburgerMenu = () => {
    setIsHamburgerMenuOpen(!isHamburgerMenuOpen);
  };

  return (
    <>
      <div className="h-[80px] bg-[white] flex items-center relative z-30">
        <div className="max-w-containerSm md:max-w-container mx-auto flex justify-between w-full items-center">
          {/* Logo */}
          <div>
            <a href={`/${currentLanguage}`}>
              <img className="md:w-[120px] w-[100px]" src={logo} alt="Logo" />
            </a>
          </div>

          {/* Menu */}
          <div className="text-[#141615] hidden md:flex items-center gap-8 relative h-[88px] ">
            <Link
              className={`${
                isActiveLink(`/${currentLanguage}`)
                  ? "text-[#B31F11]"
                  : "text-[#141615]"
              }`}
              href={`/${currentLanguage}`}
              to={`/${currentLanguage}`}
            >
              {t("Ana Səhifə")}
            </Link>

            {/* Məhsullarımız */}
            <Link
              className={`${
                isActiveLink(`/${currentLanguage}/products`)
                  ? "text-[#B31F11]"
                  : "text-[#141615]"
              }`}
              to={`/${currentLanguage}/about`}
            >
              {t("About")}
            </Link>

            {/* Oil Gas Solutions */}
            <div
              className="relative py-8"
              onMouseEnter={() => setOilGasOpen(true)}
              onMouseLeave={() => {
                setOilGasOpen(false);
                setServicesOpen(false);
                setSupplyOpen(false);
                setResatoServicesOpen(false);
                setSeperateServicesOpen(false);
              }}
            >
              <div className="flex items-center cursor-pointer">
                <p className="text-[#141615]">{t("Oil and Gas Solutions")}</p>
                <img
                  className="w-3 h-3 ml-2"
                  src={headerDropdown}
                  alt="dropdown"
                />
              </div>

              {oilGasOpen && (
                <div className="absolute top-full left-0 bg-white border border-[#DCDCDC] rounded text-[14px] text-[#141615] shadow-md min-w-[240px] z-30">
                  {/* Services */}
                  <div
                    className="relative group"
                    onMouseEnter={() => setServicesOpen(true)}
                    onMouseLeave={() => setServicesOpen(false)}
                  >
                    <div className="hover:bg-[#EBECEE] p-3 rounded cursor-pointer flex justify-between items-center">
                      <a href={`/${currentLanguage}/services`}>
                        <span>{t("Services")}</span>
                      </a>
                      <img
                        className="w-3 h-3 ml-2"
                        src={headerDropdown}
                        alt="submenu"
                      />
                    </div>

                    {servicesOpen && (
                      <div className="absolute top-0 left-full bg-white border border-[#DCDCDC] rounded shadow-md min-w-[250px] z-40">
                        {/* Seperate services */}
                        <div
                          className="relative group"
                          onMouseEnter={() => setSeperateServicesOpen(true)}
                          onMouseLeave={() => setSeperateServicesOpen(false)}
                        >
                          <div className="hover:bg-[#EBECEE] p-3 rounded cursor-pointer flex justify-between items-center">
                            <span>{t("Seperate services")}</span>
                            <img
                              className="w-3 h-3 ml-2"
                              src={headerDropdown}
                              alt="submenu"
                            />
                          </div>

                          {seperateServicesOpen && (
                            <div className="absolute top-0 left-full bg-white border border-[#DCDCDC] rounded shadow-md min-w-[240px] z-50">
                              <Link
                                to={`/${currentLanguage}/services/directional`}
                                className="block hover:bg-[#EBECEE] p-3 rounded"
                              >
                                {t("Directional drillling")}
                              </Link>
                              <Link
                                to={`/${currentLanguage}/services/drillbits`}
                                className="block hover:bg-[#EBECEE] p-3 rounded"
                              >
                                {t("Drill bits (PDC/RC)")}
                              </Link>
                              <Link
                                to={`/${currentLanguage}/services/reaming`}
                                className="block hover:bg-[#EBECEE] p-3 rounded"
                              >
                                {t("Reaming services")}
                              </Link>
                              <Link
                                to={`/${currentLanguage}/services/coring`}
                                className="block hover:bg-[#EBECEE] p-3 rounded"
                              >
                                {t("Coring & core analysis")}
                              </Link>
                              <Link
                                to={`/${currentLanguage}/services/upper`}
                                className="block hover:bg-[#EBECEE] p-3 rounded"
                              >
                                {t(
                                  "Upper & lower completion & installation of downhole equipment"
                                )}
                              </Link>
                            </div>
                          )}
                        </div>

                        <Link
                          to={`/${currentLanguage}/services/ipm`}
                          className="block hover:bg-[#EBECEE] p-3 rounded"
                        >
                          {t("IPM, ISM")}
                        </Link>
                        <Link
                          to={`/${currentLanguage}/services/geological`}
                          className="block hover:bg-[#EBECEE] p-3 rounded"
                        >
                          {t(
                            "Geological Intelligence for Drilling: Powered by Advanced Software"
                          )}
                        </Link>
                        <Link
                          to={`/${currentLanguage}/services/resato`}
                          className="block hover:bg-[#EBECEE] p-3 rounded"
                        >
                          {t("Resato High Pressure Technology")}
                        </Link>
                      </div>
                    )}
                  </div>

                  {/* Supply */}
                  <div
                    className="relative group"
                    onMouseEnter={() => setSupplyOpen(true)}
                    onMouseLeave={() => setSupplyOpen(false)}
                  >
                    <div className="hover:bg-[#EBECEE] p-3 rounded cursor-pointer flex justify-between items-center">
                      <a href={`/${currentLanguage}/supply`}>
                        <span>{t("Supply")}</span>
                      </a>
                      <img
                        className="w-3 h-3 ml-2"
                        src={headerDropdown}
                        alt="submenu"
                      />
                    </div>

                    {supplyOpen && (
                      <div className="absolute top-0 left-full bg-white border border-[#DCDCDC] rounded shadow-md min-w-[250px] z-40">
                        <Link
                          to={`/${currentLanguage}/supply/drillbits`}
                          className="block hover:bg-[#EBECEE] p-3 rounded"
                        >
                          {t("Drill bits")}
                        </Link>
                        <Link
                          to={`/${currentLanguage}/supply/directional`}
                          className="block hover:bg-[#EBECEE] p-3 rounded"
                        >
                          {t("Directional drilling (Downhole Motors)")}
                        </Link>
                        <Link
                          to={`/${currentLanguage}/supply/fiber`}
                          className="block hover:bg-[#EBECEE] p-3 rounded"
                        >
                          {t("Fiber glass tubes for cementing and coring job")}
                        </Link>
                        <Link
                          to={`/${currentLanguage}/supply/liner`}
                          className="block hover:bg-[#EBECEE] p-3 rounded"
                        >
                          {t("Liner hangers")}
                        </Link>
                        <Link
                          to={`/${currentLanguage}/supply/whipstock`}
                          className="block hover:bg-[#EBECEE] p-3 rounded"
                        >
                          {t("Whipstocks")}
                        </Link>
                        <Link
                          to={`/${currentLanguage}/supply/corebit`}
                          className="block hover:bg-[#EBECEE] p-3 rounded"
                        >
                          {t("Core bit")}
                        </Link>

                        {/* Resato subsubmenu */}
                        <div
                          className="relative group"
                          onMouseEnter={() => setResatoServicesOpen(true)}
                          onMouseLeave={() => setResatoServicesOpen(false)}
                        >
                          <div className="hover:bg-[#EBECEE] p-3 rounded cursor-pointer flex justify-between items-center">
                            <a href={`/${currentLanguage}/supply/resato`}>
                              <span>
                                {t(
                                  "Resato High Pressure Technology: High Pressure Applications"
                                )}
                              </span>
                            </a>
                            <img
                              className="w-3 h-3 ml-2"
                              src={headerDropdown}
                              alt="submenu"
                            />
                          </div>

                          {resatoServicesOpen && (
                            <div className="absolute top-0 left-full bg-white border border-[#DCDCDC] rounded shadow-md min-w-[250px] z-50">
                              <Link
                                to={`/${currentLanguage}/supply/hydro`}
                                className="block hover:bg-[#EBECEE] p-3 rounded"
                              >
                                {t(
                                  "Pressure testing: Hydrostatic pressure testing"
                                )}
                              </Link>
                              <Link
                                to={`/${currentLanguage}/supply/gas`}
                                className="block hover:bg-[#EBECEE] p-3 rounded"
                              >
                                {t("Pressure testing: Gas pressure testing")}
                              </Link>
                              <Link
                                to={`/${currentLanguage}/supply/pressure`}
                                className="block hover:bg-[#EBECEE] p-3 rounded"
                              >
                                {t("Pressure testing: Pressure test bays")}
                              </Link>
                            </div>
                          )}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              )}
            </div>

            {/* Industrial Solutions */}
            <div
              className="relative py-8"
              onMouseEnter={() => setIndustrialSolutionsOpen(true)}
              onMouseLeave={() => {
                setIndustrialSolutionsOpen(false);
                setServicesOpen(false);
                setSupplyOpen2(false);
              }}
            >
              <div className="flex items-center cursor-pointer">
                <p className="text-[#141615]">{t("Industrial Solutions")}</p>
                <img
                  className="w-3 h-3 ml-2"
                  src={headerDropdown}
                  alt="dropdown"
                />
              </div>

              {industrialSolutionsOpen && (
                <div className="absolute top-full left-0 bg-white border border-[#DCDCDC] rounded text-[14px] text-[#141615] shadow-md min-w-[240px] z-30">
                  {/* Services */}
                  <div
                    className="relative group"
                    onMouseEnter={() => setServicesOpen2(true)}
                    onMouseLeave={() => setServicesOpen2(false)}
                  >
                    <div className="hover:bg-[#EBECEE] p-3 rounded cursor-pointer flex justify-between items-center">
                      <a href={`/${currentLanguage}/industrial/services`}>
                        <span>{t("Services")}</span>
                      </a>
                      <img
                        className="w-3 h-3 ml-2"
                        src={headerDropdown}
                        alt="submenu"
                      />
                    </div>

                    {servicesOpen2 && (
                      <div className="absolute top-0 left-full bg-white border border-[#DCDCDC] rounded shadow-md min-w-[250px] z-40">
                        <Link
                          to={`/${currentLanguage}/industrial/services/industrial`}
                          className="block hover:bg-[#EBECEE] p-3 rounded"
                        >
                          {t("Industrial Insulation Services")}
                        </Link>
                        <Link
                          to={`/${currentLanguage}/industrial/services/consultancy`}
                          className="block hover:bg-[#EBECEE] p-3 rounded"
                        >
                          {t("Consultancy Services")}
                        </Link>
                        <Link
                          to={`/${currentLanguage}/industrial/services/training`}
                          className="block hover:bg-[#EBECEE] p-3 rounded"
                        >
                          {t("Training & Technical Support")}
                        </Link>
                        <Link
                          to={`/${currentLanguage}/industrial/services/maintenance`}
                          className="block hover:bg-[#EBECEE] p-3 rounded"
                        >
                          {t("Maintenance & Repair")}
                        </Link>
                      </div>
                    )}
                  </div>

                  {/* Supply */}
                  <div
                    className="relative group"
                    onMouseEnter={() => setSupplyOpen2(true)}
                    onMouseLeave={() => setSupplyOpen2(false)}
                  >
                    <div className="hover:bg-[#EBECEE] p-3 rounded cursor-pointer flex justify-between items-center">
                      <a href={`/${currentLanguage}/industrial/supply`}>
                        <span>{t("Supply")}</span>
                      </a>
                      <img
                        className="w-3 h-3 ml-2"
                        src={headerDropdown}
                        alt="submenu"
                      />
                    </div>

                    {supplyOpen2 && (
                      <div className="absolute top-0 left-full bg-white border border-[#DCDCDC] rounded shadow-md min-w-[250px] z-40">
                        <Link
                          to={`/${currentLanguage}/industrial/supply/pumps-compressor`}
                          className="block hover:bg-[#EBECEE] p-3 rounded"
                        >
                          {t("Pumps, compressors")}
                        </Link>
                        <Link
                          to={`/${currentLanguage}/industrial/supply/gloves`}
                          className="block hover:bg-[#EBECEE] p-3 rounded"
                        >
                          {t("PPE Equipment")}
                        </Link>
                        <Link
                          to={`/${currentLanguage}/industrial/supply/hand-tools`}
                          className="block hover:bg-[#EBECEE] p-3 rounded"
                        >
                          {t("Hand tools, measuring instruments")}
                        </Link>
                      </div>
                    )}
                  </div>
                </div>
              )}
            </div>

            <Link
              className={`${
                isActiveLink(`/${currentLanguage}/qhse`)
                  ? "text-[#B31F11]"
                  : "text-[#141615]"
              }`}
              to={`/${currentLanguage}/qhse`}
            >
              {t("QHSE")}
            </Link>
          </div>

          <div className="text-[#141615] hidden md:flex items-center gap-8 relative h-[88px] ">
            <Link to={`/${currentLanguage}/contact`}>
              <button className="w-[122px] h-[48px] bg-[#B31F11] text-[white] font-medium rounded text-[14px]">
                {t("Contact")}
              </button>
            </Link>
          </div>

          <button onClick={toggleHamburgerMenu} className="md:hidden">
            <i className="fa-solid fa-bars text-[24px]"></i>
          </button>

          {isHamburgerMenuOpen && (
            <div className="fixed inset-0 overflow-y-auto  bg-[white] z-40 transition-transform duration-300 ease-in-out transform translate-x-0 shadow-lg">
              <div className="flex flex-col max-w-md mx-auto px-4 pt-6 min-h-screen ">
                {/* Üst kısım: Logo ve Kapatma */}
                <div className="flex justify-between items-center mb-6">
                  <a href={`/${currentLanguage}`}>
                    <img src={logo} alt="Logo" className="w-[80px]" />
                  </a>
                  <button onClick={toggleHamburgerMenu} aria-label="Close Menu">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="black"
                      className="w-6 h-6"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M6 18L18 6M6 6l12 12"
                      />
                    </svg>
                  </button>
                </div>

                {/* Menü Linkleri */}
                <nav className="flex flex-col gap-2 text-base font-medium mt-7">
                  {menuItems.map((item, index) => {
                    const hasSubmenu = !!item.submenu;
                    const fullPath = `/${currentLanguage}${item.path}`;
                    const isActive = isActiveLink(fullPath);

                    return (
                      <div key={index}>
                        <div className="flex justify-between items-center px-3 py-2 bg-gray-100 rounded">
                          <a
                            href={fullPath}
                            className={`font-semibold ${
                              isActive ? "text-[#B31F11]" : "text-black"
                            }`}
                          >
                            {item.label}
                          </a>
                          {hasSubmenu && (
                            <button
                              onClick={() => toggleSubmenu(index)}
                              className="text-sm"
                            >
                              <i
                                className={`fas fa-chevron-${
                                  openIndex === index ? "up" : "down"
                                }`}
                              />
                            </button>
                          )}
                        </div>

                        {hasSubmenu && openIndex === index && (
                          <div className="mt-1 ml-4 flex flex-col gap-1 border-l border-gray-300 pl-3">
                            {item.submenu.map((sub, subIndex) => {
                              const hasNested = !!sub.submenu;
                              const subPath = `/${currentLanguage}${sub.path}`;
                              const subActive = isActiveLink(subPath);

                              return (
                                <div key={sub.path}>
                                  <div className="flex justify-between items-center px-2 py-1">
                                    <a
                                      href={subPath}
                                      className={`${
                                        subActive
                                          ? "text-[#B31F11] font-semibold"
                                          : "text-black"
                                      }`}
                                    >
                                      {sub.label}
                                    </a>
                                    {hasNested && (
                                      <button
                                        onClick={() =>
                                          toggleNestedSubmenu(subIndex)
                                        }
                                        className="text-xs"
                                      >
                                        <i
                                          className={`fas fa-chevron-${
                                            openSubIndex === subIndex
                                              ? "up"
                                              : "down"
                                          }`}
                                        />
                                      </button>
                                    )}
                                  </div>

                                  {hasNested && openSubIndex === subIndex && (
                                    <div className="ml-4 mt-1 flex flex-col gap-1 border-l border-gray-300 pl-3">
                                      {sub.submenu.map((nested) => {
                                        const nestedPath = `/${currentLanguage}${nested.path}`;
                                        const nestedActive =
                                          isActiveLink(nestedPath);
                                        return (
                                          <a
                                            key={nested.path}
                                            href={nestedPath}
                                            className={`py-1 px-2 text-sm ${
                                              nestedActive
                                                ? "text-[#B31F11] font-semibold"
                                                : "text-black"
                                            }`}
                                          >
                                            {nested.label}
                                          </a>
                                        );
                                      })}
                                    </div>
                                  )}
                                </div>
                              );
                            })}
                          </div>
                        )}
                      </div>
                    );
                  })}
                </nav>
                <div className=" mb-[60px]">
                  <a href={`/${currentLanguage}/contact`}>
                    <button className="bg-[#B31F11] text-[white] font-medium h-[36px] w-[162px] rounded mt-4">
                      {t("Contact")}
                    </button>
                  </a>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default Header;
